module.exports = __webpack_public_path__ + "img/01.135b4ab9.jpg";